import { handleSendFunctionResponseToRFPAgent } from "../services/handleSendFunctionResponseToRFPAgent";

export const getEntireRFPState = async (updatedChatSession, documentData, chatSessionRef, setChatSession, userInfo) =>{
    const entireRFPState = {...documentData};
   const responseMessage = `FunctionResponse: The current state of the entire RFP is as follows: ${JSON.stringify(entireRFPState, null, 2)}.`
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    }
    await handleSendFunctionResponseToRFPAgent(response, updatedChatSession, setChatSession, chatSessionRef, userInfo);
}